import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import SplashView from '../shared/SplashView.vue';









import HomeWebContent from '@/views/platforms/web/HomeWebContent.vue';
import { onMounted, ref, onUnmounted } from 'vue';
import { ISesionApp } from '@/model/ISesionApp';
import {useMainStore} from '@/store/main-store';
import {useServicesFactoryStore}  from '@/store/services-factory-store';
import { ISesionUsuarios, SesionUsuarios } from '@/model/ISesionUsuarios';
import { Subscription } from 'rxjs';
import SecurityManagerService from '@/services/SecurityManagerService';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeDefault',
  setup(__props) {

let HomeContent:any = null;
HomeContent = HomeWebContent;

const loginService = useServicesFactoryStore().getLoginService;
const securityService:SecurityManagerService = useServicesFactoryStore().getSecurityManagerService;
let sesion = ref<ISesionApp|null>(null);
const signalRService = useServicesFactoryStore().getSignalRService;
const mainStore = useMainStore();
let menuApp:any = ref(null);
let hubSesion = ref<ISesionUsuarios>(new SesionUsuarios());
let hubSesionSubscription: Subscription;

const getMenus = () =>
{        
    menuApp.value = securityService.getMenusBySession(sesion.value);    
}

const connectSignalR = async () =>
{
    await signalRService.startsesion();
};
onMounted(async ()=>
{    
    sesion.value = await loginService.getSession();
    hubSesionSubscription = signalRService.SesionHub.subscribe((hub: any) => 
    {        
       hubSesion.value = hub? hub:new SesionUsuarios(); 
       mainStore.setHubConnection(hubSesion.value);      
    });  
    await connectSignalR();
    getMenus();    
});
onUnmounted(()=>
{
    if (hubSesionSubscription)
    {
        hubSesionSubscription.unsubscribe();
    }
});

return (_ctx: any,_cache: any) => {
  return (_unref(sesion) && _unref(menuApp) && _unref(menuApp).length >0)
    ? (_openBlock(), _createBlock(_unref(HomeContent), {
        key: 0,
        sesionApp: _unref(sesion),
        menus: _unref(menuApp),
        hubSesion: _unref(hubSesion)
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["sesionApp", "menus", "hubSesion"]))
    : (_openBlock(), _createBlock(SplashView, { key: 1 }))
}
}

})